import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { blogs } from '../utilities/blogs';
import { BlogsPageSEO } from '../../SeoTags';

const BlogsPage = () => {
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.1
            }
        }
    };

    const cardVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.5
            }
        },
        hover: {
            y: -10,
            transition: {
                duration: 0.2
            }
        }
    };

    return (
        <>
        <BlogsPageSEO />
        <div className="min-h-screen bg-softwhite py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-7xl mx-auto">
                <motion.div
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    className="text-center mb-12"
                >
                    <h1 className="text-4xl md:text-5xl font-bold text-darkbrown mb-4">
                        Medical Insights & Updates
                    </h1>
                    <p className="text-charcol text-lg max-w-2xl mx-auto">
                        Expert perspectives on surgical gastroenterology, transplantation, and advanced surgical procedures.
                    </p>
                </motion.div>

                <motion.div
                    variants={containerVariants}
                    initial="hidden"
                    animate="visible"
                    className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8"
                >
                    {blogs.map((blog) => (
                        <motion.div
                            key={blog.id}
                            variants={cardVariants}
                            whileHover="hover"
                            className="bg-white rounded-xl shadow-lg overflow-hidden"
                        >
                            <div className="flex flex-col h-full">
                                <div className="relative h-48 overflow-hidden">
                                    <img
                                        src={blog.imageUrl}
                                        alt={blog.title}
                                        className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-300"
                                    />
                                  
                                </div>

                                <div className="p-6 flex flex-col flex-grow">
                                    <div className="flex-grow">
                                        
                                        <h2 className="text-xl font-semibold mb-3 text-darkbrown hover:text-earthybeige transition-colors duration-200">
                                            {blog.title}
                                        </h2>
                                        <p className="text-charcol mb-4 line-clamp-2">
                                            {blog.description}
                                        </p>
                                    </div>

                                    <div className="flex flex-wrap gap-2 mb-4">
                                        {blog.tags.map((tag, index) => (
                                            <span
                                                key={index}
                                                className="px-2 py-1 rounded-full text-xs"
                                                style={{
                                                    backgroundColor: `${blog.color}20`,
                                                    color: blog.color
                                                }}
                                            >
                                                {tag}
                                            </span>
                                        ))}
                                    </div>

                                    <Link
                                        to={`/blog/${blog.id}`}
                                        className="inline-flex items-center text-sage hover:text-darkbrown transition-colors duration-200"
                                    >
                                        Read More
                                        <svg
                                            className="w-4 h-4 ml-2"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth="2"
                                                d="M14 5l7 7m0 0l-7 7m7-7H3"
                                            />
                                        </svg>
                                    </Link>
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </motion.div>
            </div>
        </div>
        </>
    );
};

export default BlogsPage;